
import { fetchAllOrder, fetchbestSellingItems } from '@services/api/orders/orderServices';
import { useQuery } from '@tanstack/react-query';
import { OrdersResponse,BestSeller } from 'types/orders/orderTypes';
export const useOrders=(id:string)=>{
    const {data,isLoading,error}=useQuery<OrdersResponse,Error>({
            queryKey:['orders'],
            queryFn:()=>fetchAllOrder(id),
            refetchOnWindowFocus: false
    });
    return{
        data:data,
        isLoading,
        error
    }
}

export const useBestSeller=(id:string)=>{
    const {data,isLoading,error}=useQuery<BestSeller,Error>({
            queryKey:['bestItems'],
            queryFn:()=>fetchbestSellingItems(id),
            refetchOnWindowFocus: false
    });
    return{
        data:data,
        isLoading,
        error
    }
}